import Phaser from 'phaser'

const COINS_PER_BLOCK = 3

export default abstract class NonPlayable extends Phaser.Physics.Arcade.Sprite
{
    abstract getName(): string
	private dir: number = -1
	private walking: boolean = false
	private bubble: Phaser.GameObjects.Image

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: string | number)
	{
		super(scene, x, y, texture, frame);
		this.anims.play(`${this.getName()}-idle-down`);
		this.bubble = this.scene.add.image(x, y - 24, 'bubble', 'bubble 2.aseprite')
		this.bubble.z = 10001
		this.bubble.visible = false
	}

	halt() {
		this.anims.play(`${this.getName()}-idle-down`);
		this.dir = -1
		this.walking = false
		this.body.stop()
	}

	bump() {
		const save = this.dir
		this.walking = true
		while (save == this.dir) {
			this.dir = Phaser.Math.Between(0,4)
		}
	}

	showBubble(show: boolean) {
		if (show) 
			this.bubble.setPosition(this.body.x, this.body.y - 16)
		this.bubble.visible = show
	}

	update()
	{
		const speed = 50

		const leftDown = this.dir == 0
		const rightDown = this.dir == 1
		const upDown = this.dir == 2
		const downDown = this.dir == 3

		if (leftDown)
		{
			this.anims.play(`${this.getName()}-walk-left`, true)
			this.setVelocity(-speed, 0)
		}
		else if (rightDown)
		{
			this.anims.play(`${this.getName()}-walk-right`, true)
			this.setVelocity(speed, 0)
		}
		else if (upDown)
		{
			this.anims.play(`${this.getName()}-walk-up`, true)
			this.setVelocity(0, -speed)
		}
		else if (downDown)
		{
			this.anims.play(`${this.getName()}-walk-down`, true)
			this.setVelocity(0, speed)
		}
		else
		{
			if (this.walking) {
				const parts = this.anims.currentAnim.key.split('-')
				parts[1] = 'idle'
				this.anims.play(parts.join('-'))
				this.bump()
			}
		}
	}

}

export class Alchemist extends NonPlayable {
    public getName() { return "alchemist"; }
}

export class Barmaid extends NonPlayable {
    public getName() { return "barmaid"; }
}
export class Bartender extends NonPlayable {
    public getName() { return "bartender"; }
}
export class Blacksmith extends NonPlayable {
    public getName() { return "blacksmith"; }
}
export class Fisherman extends NonPlayable {
    public getName() { return "fisherman"; }
}
export class Kid1 extends NonPlayable {
    public getName() { return "kid01"; }
}
export class Kid2 extends NonPlayable {
    public getName() { return "kid02"; }
}
export class Merchant extends NonPlayable {
    public getName() { return "merchant"; }
}
export class Minter extends NonPlayable {
	private coins : number
	private bubble: Phaser.GameObjects.Image
	private text  : Phaser.GameObjects.Text

	public mint() {
		this.anims.play('minting')
	}

	public minted() {
		this.anims.play('minted')
		this.coins -= COINS_PER_BLOCK
		if (this.coins < 0) this.coins = 0
	}

	public setMempool(coins : number) {
		this.coins = Math.min(COINS_PER_BLOCK, coins)
		if (this.coins > 0) {
			// this.text.text = "" + this.coins
			this.bubble.visible = true
			// this.text.visible = true
		}
		else {
			// this.text.visible = false
			this.bubble.visible = false
		}
	}

    public getName() { return "minter"; }

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string, frame?: string | number)
	{
		super(scene, x, y, texture, frame);
		this.mint()
		this.coins = 0;
		this.bubble = scene.add.image(x, y - 24, 'bubble', 'bubble 1.aseprite')
		this.bubble.visible = false
		this.bubble.z = 10001
		this.text = this.scene.add.text(this.bubble.x, this.bubble.y - 9, '--', { fontFamily: '"Monospace"', fontSize: '8', color: '#000'})
		this.text.visible = false
	}
}
